import React from 'react';
import { Layout, Button } from 'antd';
import styles from './css/Error.module.css'
import { Header, Footer, FormMessage } from './CorePageContents';
import * as CONSTANTS from '../../constants/constants';

const { Content } = Layout;

export const PrimeNoContractError = () => {

  // スキルマップマニュアルページに遷移
  const openManualClick = () => {
    window.open(CONSTANTS.URL_SMS_MANUAL);
  }

  return (
    <Layout>
      <Header />
      <Content>
        <div className={styles.mainMessage}>契約状況をご確認ください</div>
        <br />
        <div className={styles.subMessage}>
          スキルマップサイトのご利用にはプライムサービスをご契約いただく必要がございます。<br />
          お手数ですが、貴社の企業担当者様に契約状況のご確認をお願いいたします。
          <br />
          <br />
          また、スキルマップサイトの操作マニュアルをご用意しています。<br />
          ご不明な点がありましたらマニュアルをご参照ください。
          <br />
          <br />
        </div>
        <Button
          className={styles.primeSysButton}
          onClick={openManualClick}
        >
          マニュアルを見る
        </Button>
        <br />
        <br />
        <br />
        <div className={styles.subMessage}>協力会社の立場でご利用の方は右上の切り替えボタンから協力会社専用画面へ移動をお願いいたします。</div>
        <br />
        <FormMessage />
      </Content>
      <Footer />
    </Layout>
  );
}
